/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AppError } from './AppError';

export class UnauthenticatedError extends AppError {
    constructor() {
        super('Not Authenticated', 'saml token or access token does not exist');
    }
}
